"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sectionItemBaseTheme = function (_a) {
    var _b;
    var MAX_L = _a.MAX_L;
    return ({
        sectionItem: (_b = {
                "&:hover": {
                    textDecoration: "none",
                },
                "&:not(:last-child)": {
                    marginBottom: "1rem"
                }
            },
            _b[MAX_L] = {
                "& > p": {
                    fontSize: "14px"
                }
            },
            _b.display = "block",
            _b),
        sectionItemTitle: {
            color: "#009AD9",
            fontSize: "1rem",
            fontWeight: "bold",
            textDecoration: "underline",
        },
        sectionItemDesc: {
            fontSize: "12px !important",
            color: "#000000bd",
            height: "36px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "-webkit-box",
            "-webkit-line-clamp": 2,
            "-webkit-box-orient": "vertical",
        }
    });
};
exports.default = sectionItemBaseTheme;
//# sourceMappingURL=sectionItem.js.map